import React from 'react';
import PropTypes from 'prop-types';
import { createLipidograma, getHistoricoLipidograma } from '../../../domain/api/MedicionesApi';
import {
	RANGOS_LIPIDOGRAMA,
	textoRangoPermitido,
	validarLipidograma,
} from '../../utils/HelpValidacionMediciones';
import { COLUMNAS_HISTORIAL_LIPIDOGRAMA } from '../../utils/HelpMediciones';
import usePanelMedicion from './usePanelMedicion';
import useHistorialMedicion from './useHistorialMedicion';
import HistorialMediciones from './HistorialMediciones';
import PanelMedicion from './PanelMedicion';
import CampoMedicion from './CampoMedicion';
import medicionesStyles from './medicionesStyles';

const VALORES_INICIALES = { colesterol: '', ldl: '', hdl: '', trigliceridos: '' };

// Orden visual y de tabulación: Colesterol total | LDL / HDL | Triglicéridos
const CAMPOS = [
	{ clave: 'colesterol', label: 'Colesterol total' },
	{ clave: 'ldl', label: 'LDL' },
	{ clave: 'hdl', label: 'HDL' },
	{ clave: 'trigliceridos', label: 'Triglicéridos' },
];

/** Panel de registro de lipidograma: cuatro cifras en mg/dL, una sola petición. */
const PanelLipidograma = ({ modulo, numeroDocumento, evbi, onRegistrado }) => {
	const classes = medicionesStyles();
	const historial = useHistorialMedicion({ cargar: getHistoricoLipidograma, numeroDocumento });
	const panel = usePanelMedicion({
		valoresIniciales: VALORES_INICIALES,
		validar: validarLipidograma,
		enviar: createLipidograma,
		numeroDocumento,
		evbi,
		onExito: () => {
			// Solo con codigoRespuesta '0000': usePanelMedicion no llama onExito en error
			historial.recargar();
			if (onRegistrado) {
				onRegistrado(modulo.id);
			}
		},
	});

	return (
		<PanelMedicion
			modulo={modulo}
			guardando={panel.guardando}
			bloqueado={panel.bloqueado}
			resultado={panel.resultado}
			onGuardar={panel.guardar}
			onLimpiar={panel.limpiar}
			pie={
				<HistorialMediciones
					id="lipidograma"
					columnas={COLUMNAS_HISTORIAL_LIPIDOGRAMA}
					historial={historial}
				/>
			}
		>
			<div className={classes.rejillaLipidograma}>
				{CAMPOS.map(({ clave, label }) => (
					<CampoMedicion
						key={clave}
						id={`medicion-${clave}`}
						label={label}
						unidad={RANGOS_LIPIDOGRAMA[clave].unidad}
						value={panel.valores[clave]}
						onChange={(texto) => panel.setValor(clave, texto)}
						error={panel.errores[clave]}
						ayuda={textoRangoPermitido(RANGOS_LIPIDOGRAMA[clave])}
					/>
				))}
			</div>
		</PanelMedicion>
	);
};

PanelLipidograma.propTypes = {
	modulo: PropTypes.shape({
		id: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		descripcion: PropTypes.string,
	}).isRequired,
	numeroDocumento: PropTypes.string,
	evbi: PropTypes.number,
	onRegistrado: PropTypes.func,
};

export default PanelLipidograma;
